/** Public visitors and logged-out tabs — registration/maintenance; admin saves sync via BroadcastChannel. */
export const SITE_SETTINGS_POLL_INTERVAL_PUBLIC_MS = 60_000;

/** Signed-in app (dashboard, etc.) — same cadence; maintenance still matters. */
export const SITE_SETTINGS_POLL_INTERVAL_SIGNED_IN_MS = 60_000;

/** BroadcastChannel — other tabs refetch site settings when a super admin saves App Settings. */
export const SITE_SETTINGS_BROADCAST_CHANNEL = 'bhg-site-settings';

export const SITE_SETTINGS_CHANGED_EVENT = 'bhg-site-settings-changed';
